import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import Login from "@/pages/admin/Login";
import Admin from "@/pages/admin/Admin";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center text-white/50">
        Laden...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <SettingsProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/projecten/:slug" element={<ProjectDetail />} />
                <Route path="/login" element={<Login />} />
                <Route
                  path="/admin"
                  element={
                    <Protected>
                      <Admin />
                    </Protected>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Toaster position="bottom-right" theme="dark" />
            </BrowserRouter>
          </SettingsProvider>
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
